'use client'

import type { ColumnDef } from '@tanstack/react-table'
import Zoom from 'react-medium-image-zoom'

import type { RoyaltyDetailBookEntry } from '@package/api'
import { formatCurrency } from '@helper/utils/format'

export const royaltyDetailsColumns: ColumnDef<RoyaltyDetailBookEntry>[] = [
  {
    id: 'property',
    accessorKey: 'bookTitle',
    enableHiding: false,
    header: 'Property',
    cell: ({ row }) => {
      const { bookTitle, authorName, coverUrl } = row.original
      return (
        <div className='srd:flex srd:items-start srd:gap-3 srd:w-full srd:min-w-[300px] srd:sm:min-w-[500px]'>
          <Zoom>
            <img
              src={coverUrl}
              alt={bookTitle}
              className='srd:h-24 srd:w-auto srd:aspect-3/4 srd:object-cover srd:rounded'
            />
          </Zoom>
          <div className='srd:min-w-0 srd:flex-1 srd:flex srd:flex-col srd:overflow-hidden'>
            <p className='srd:min-w-0 srd:font-semibold srd:text-foreground srd:line-clamp-2' title={bookTitle}>
              {bookTitle}
            </p>
            {authorName && (
              <p className='srd:text-neutrals-n-75 srd:text-sm srd:truncate' title={authorName}>
                {authorName}
              </p>
            )}
          </div>
        </div>
      )
    },
  },
  {
    id: 'uniqueSession',
    accessorKey: 'uniqueSession',
    enableHiding: true,
    header: 'Unique Sessions',
    cell: ({ row }) => <div className='srd:text-nowrap'>{row.original.uniqueSession}</div>,
  },
  {
    id: 'sessionRate',
    accessorKey: 'sessionRate',
    enableHiding: true,
    header: 'Session Rate',
    cell: ({ row }) => <div className='srd:text-nowrap'>{row.original.sessionRate.toFixed(6)}</div>,
  },
  {
    id: 'earnedAmount',
    accessorKey: 'earnedAmount',
    enableHiding: true,
    header: () => <span className='srd:text-right srd:w-full srd:block'>Earned Royalty</span>,
    cell: ({ row }) => {
      const { earnedAmount, currency } = row.original
      return (
        <div className='srd:text-foreground srd:text-right srd:font-semibold srd:text-nowrap'>
          {formatCurrency(earnedAmount, { currency, maximumFractionDigits: 2 })}
        </div>
      )
    },
  },
]
